import React, { useState } from "react";
import VerificationInput from "react-verification-input";
import { useSessionContext } from "components/Session";
import { userAuthSetup, newSession } from "api.mjs";
import log from "loglevel";
import "sass/awaiting-confirmation.scss";
import { sendVerificationEmail } from "./LoginWithEmailForm";
import Spinner from "react-bootstrap/Spinner";

const AwaitingConfirmation = ({
  email,
  confirmationId,
  setConfirmationId,
  setLoginState,
  setShowModal,
  onLoginSuccess,
}) => {
  const { sessionContext, setSessionContext } = useSessionContext();
  log.debug("AwaitingConfirmation RENDER confirmation_id", confirmationId);

  const [codeValue, setCodeValue] = useState("");
  const [checkingCodeValidity, setCheckingCodeValidity] = useState(false);
  const [invalidCode, setInvalidCode] = useState(false);
  const [loggingIn, setLoggingIn] = useState(false);
  const [signUpLoading, setSignUpLoading] = useState(false);
  const [loginInitiated, setLoginInitiated] = useState(false);

  const createNewSession = (sessionContext, setSessionContext) => {
    newSession({ context: { sessionContext } })
      .then((serverSessionContext) => {
        log.debug("Server Returned:", serverSessionContext);
        const newSessionContext = {
          ...sessionContext,
          ...serverSessionContext,
          isLoggedIn: true,
          userInfo: { email },
        };
        setSessionContext(newSessionContext);
        setLoggingIn(false);
        setShowModal(false);
        onLoginSuccess && onLoginSuccess(newSessionContext);
      })
      .catch((error) => {
        log.error("Unexpected error while logging in:", error);
        log.error(typeof error);
        log.info(error);
        setLoggingIn(false);
      });
  };

  const doLogin = (confirmationCode) => {
    log.debug("Logging in..");
    setLoggingIn(true);
    const newSessionContext = {
      isAdminUser: false,
      loginWithEmail: {
        email,
        confirmation_id: confirmationId,
        confirmation_code: confirmationCode,
      },
    };
    createNewSession(newSessionContext, setSessionContext);
  };

  const onEmailCodeEnterred = async (confirmationCode) => {
    log.info("AwaitingConfirmation onEmailCodeEnterred", confirmationCode);
    setCheckingCodeValidity(true);
    setInvalidCode(false);
    try {
      const data = {
        type: "confirm-email",
        confirmation_id: confirmationId,
        confirmation_code: confirmationCode,
        email,
      };
      const result = await userAuthSetup({ data, context: { sessionContext } });
      log.info("AwaitingConfirmation LoginWithEmailForm result", result);
      const { status } = result;
      if (status === "not-found") {
        setInvalidCode(true);
        setCodeValue("");
      } else if (status === "confirmed") {
        doLogin(confirmationCode);
        setLoginInitiated(true);
        // setConfirmationCode(confirmationCode);
        // setLoginState("received-confirmation-code");
      } else {
        log.error("AwaitingConfirmation unknown status:", status);
        setLoginInitiated(false);
      }
      log.debug("AwaitingConfirmation LoginWithEmailForm result", result);
    } catch (error) {
      log.error("AwaitingConfirmation onEmailCodeEnterred", error);
      setLoginInitiated(false);
    } finally {
      setCheckingCodeValidity(false);
    }
  };
  const resendCodeHandler = () => {
    sendVerificationEmail({
      email,
      sessionContext,
      setSignUpLoading,
      setLoginState,
      setShowModal,
      setShowPopup: () => {},
      setConfirmationId,
    });
  };

  return (
    <>
      <div className="confirmation-content">
        <div className="text-mail">
          <span className="text-sent">An Verification Code was sent to: </span>
          <span className="text-highlight">{email}</span>
        </div>
        <p className="text-wait">
          Please check your email For Verification Code
        </p>
        {!loginInitiated ? (
          <>
            <div className="otp-container">
              <VerificationInput
                value={codeValue}
                length={5}
                validChars="0-9"
                inputProps={{ inputMode: "numeric" }}
                onComplete={onEmailCodeEnterred}
                onChange={(e) => setCodeValue(e)}
                autoFocus={true} // Focus the input automatically as soon as it is rendered.
              />
            </div>

            {checkingCodeValidity && (
              <div className="text-verify">
                Verifying your code..
                <div className="jumping-dots-loader">
                  <span></span> <span></span> <span></span>
                </div>
              </div>
            )}
            {invalidCode && (
              <div className="text-wrong-code text-danger">
                Invalid code. Please try again. ⚠️
              </div>
            )}

            <div className="resend-container">
              <span className="text-resend">Didn’t Get Verification Code?</span>
              <button
                className="btn border-0"
                onClick={resendCodeHandler}
                disabled={signUpLoading}
              >
                {signUpLoading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="grow"
                      role="status"
                      aria-hidden="true"
                      size="sm"
                    />
                    Resending...
                  </>
                ) : (
                  <>Resend Code</>
                )}
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="text-wait">
              <Spinner
                as="span"
                animation="grow"
                role="status"
                aria-hidden="true"
                size="sm"
              />
              Please wait...
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AwaitingConfirmation;
